<mat-form-field appearance="fill">
  <mat-label>Szervezeti egység neve</mat-label>
  <input matInput [(ngModel)]="name">
</mat-form-field>
<div class="save-button">
  <app-button
    (click)="save()"
    [title]="'Mentés'"
    [customColor]="'green'"
  ></app-button>
</div>